@if (task) {
  <div class="task-detail-container">
    <div class="task-header">
      <h1>{{ task.title }}</h1>
      <div class="task-meta">
        <div class="target-date">
          <mat-icon>event</mat-icon>
          <span>{{ task.targetDate | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="priority" [ngClass]="'priority-' + task.priority.toLowerCase()">
          <span>{{ task.priority === 'HIGH' ? 'Alta' : task.priority === 'NORMAL' ? 'Normal' : 'Baixa' }}</span>
        </div>
        <div class="status">
          <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select [value]="task.status" (selectionChange)="onStatusChange($event.value)">
              @for (status of statusOptions; track status) {
                <mat-option [value]="status">
                  {{ status === 'OPEN' ? 'ABERTO' : 'FECHADO' }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="task-author">
      <mat-icon>person</mat-icon>
      <span>{{ task.authorName }}</span>
    </div>
    <div class="task-description">
      <h2>Descrição</h2>
      <p>{{ task.body }}</p>
    </div>
    <div class="task-actions">
      <button mat-raised-button color="warn" (click)="onDelete()">
        <mat-icon>delete</mat-icon>
        Excluir
      </button>
    </div>
  </div>
}
